import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {decrementLoginStep, incrementLoginStep} from "../../../../Features/Misc/loginSlice";

const BackAndForthButton = ({type}) => {
    const dispatch = useDispatch()
    const { loginStep } = useSelector((state) => state.login)

    const handleClick = () => {
        if (type === "decrement") {
            dispatch(decrementLoginStep());
        } else if (type === "increment") {
            dispatch(incrementLoginStep());
        }
    };

    const disabled = ((type === "decrement" && loginStep === 0) || (type === "increment" && loginStep >= 1))

    let status = disabled ? "opacity-40 " : " ";


    return (
        <button
            onClick={() => handleClick()}
            className={`${status} flex items-center arrow-container w-12 h-12 border-2 border-pink-icon text-center p-2 rounded-lg `}
            disabled={disabled}
        >
                <i className={type === "decrement" ? `ri-arrow-left-line` : type === "increment" ? `ri-arrow-right-line` : ""}></i>
        </button>
    );
};

export default BackAndForthButton;